const FOCUSABLE_SELECTOR =
  'a[href], button, input, select, textarea, [tabindex]';

// Unlike `visibility`, `display` isn't an inherited CSS property, so a
// display:none ancestor (e.g. a collapsed accordion panel) doesn't show up
// in a descendant's own computed style — walk up to the container to catch it.
function isDisplayNone(element: Element, container: HTMLElement): boolean {
  let node: Element | null = element;
  while (node) {
    if (getComputedStyle(node).display === 'none') return true;
    if (node === container) return false;
    node = node.parentElement;
  }
  return false;
}

export function getTabbableElements(container: HTMLElement): HTMLElement[] {
  return Array.from(
    container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)
  ).filter(el => {
    if (el.matches(':disabled') || el.tabIndex < 0) return false;
    if (getComputedStyle(el).visibility === 'hidden') return false;
    return !isDisplayNone(el, container);
  });
}
